<template>
  <div class="corpotateTrainingHero">
    <u-modal
      v-model="contactUs"
      title="Request More Information"
      action="Request Quotation"
      @action="submit"
    >
      <uform>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Full Name"
            v-model="model.data.data.name"
            suggest="ie. Sabit Hossain"
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Company"
            v-model="model.data.data.company"
            suggest="ie. Upskill"
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Email"
            v-model="model.data.data.email"
            suggest="ie. Sabit@Hossain.com"
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Phone"
            v-model="model.data.data.phone"
            suggest="ie. 01712345678"
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Designation"
            v-model="model.data.data.designation"
            suggest="ie. Software Engineer"
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput placeholder="Number of Attendees" suggest="ie. 4"></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Details"
            suggest="ie. Tell us more about the workshop you are interested on"
            type="textarea"
            v-model="model.data.data.details"
          ></uinput>
        </ulabel>
      </uform>
    </u-modal>
    <uhero
      :image="heroData.image"
      :title="heroData.title"
      :body="heroData.body"
    >
      <template v-slot:btn>
        <h4>Complete <span style="background-color:yellow; color: black">FREE</span> Online Classroom Management System</h4>
        <ul style="padding-left: 20px;">
          <li>Create Classes</li>
          <li>Share Assignments</li>
          <li>Become Organized</li>
        </ul>
        <u-btn-outlined @click.native.prevent="openWindow" clas="pl-2">Request Free Trial</u-btn-outlined
        >
      </template>
      <div class="container">
        <div class="classroom-hero-mobile">
          <div class="workshop_hero_content_mobile">
            <h3 class="workshop__text_mobile">
              {{ heroData.title }}
            </h3>
            <h4>Complete <span style="background-color:yellow; color: black">FREE</span> Online Classroom Management System</h4>
            <ul style="padding-left: 20px;">
              <li>Create Classes</li>
              <li>Share Assignments</li>
              <li>Become Organized</li>
            </ul>
            <u-btn-outlined @click.native.prevent="openWindow">Request Free Trial</u-btn-outlined>
          </div>
        </div>
      </div>
    </uhero>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: {
        data: {
          data: {}
        },
        type: "sponsorship",
        status: "request"
      },
      contactUs: false,
      heroData: {
        title: "Upskill Classroom",
        body: "",
        image: require("../../assets/clbanner.png")
      }
    };
  },
  methods: {
    openWindow() {
      window.open('/classroom#uc_seek', "_self")
    },
    submit() {
      this.$upskill
        .vault(this.model)
        .then(() => {
          this.SuccessAlert("Request submitted!");
          this.contactUs = false
        })
        .error(() => {
          this.ErrorAlert("Something went wrong.");
        });
    }
  }
};
</script>
